import * as React from 'react';
import Svg, {SvgProps, G, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={800}
    height={800}
    viewBox="0 0 21 21"
    {...props}
    fill={'none'}
    stroke={'none'}>
    <G
      fill="none"
      fillRule="evenodd"
      stroke={props.fill || '#070A7A'}
      strokeLinecap="round"
      strokeLinejoin="round">
      <Path d="M3.5 8.5a5 5 0 1 0 1.057-3.074" />
      <Path d="M4.5 1.5v4h4M17.5 17.5l-5.379-5.379" />
    </G>
  </Svg>
);
export default SvgComponent;
